/**
 * Get the default name based on a mime type.
 * @param mime - The mime type to get the default name for.
 * @returns The default name for the mime type.
 */
export function defaultNameFromMime(mime: string) {
  const ext = mime.split('/')[1];
  return `file.${ext}`;
}

/**
 * Get the default name for a blob.
 * @param blob - The blob to get the default name for.
 * @returns The default name for the blob.
 */
export function defaultNameFromBlob(blob: Blob) {
  if (blob instanceof File) {
    return blob.name;
  }
  return defaultNameFromMime(blob.type);
}
